import { render, staticRenderFns } from "./index.vue?vue&type=template&id=764b54c3&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=764b54c3&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b54c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764b54c3')) {
      api.createRecord('764b54c3', component.options)
    } else {
      api.reload('764b54c3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=764b54c3&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&", function () {
      api.rerender('764b54c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/kbVlog/update/index.vue"
export default component.exports